import {Fragment} from "react";
import {TranslationFunction, TranslationValues, useTranslation} from "i18nano";

function useFormattingTranslation() {
    const t = useTranslation();
    return (text: string, values?: TranslationValues, customComponents?: any) => formating(t, text, values, customComponents);
}

function formating(t: TranslationFunction, text: string, values?: TranslationValues, customComponents?: any) {
    const boldRegex = /<b.*>.*<\/b>/gm;
    const description = t(text, values);

    let splitDescription = description.split(boldRegex);
    let matchesDescription = Array.from(description.matchAll(boldRegex));

    return splitDescription.map((a, index) => {
        let component: any = null;
        if (matchesDescription[index]) {
            const description: string = matchesDescription[index].toString().replaceAll(/<\/b>/gm, "").replaceAll(/<b.*>/gm, "");
            component = <b>{description}</b>;
        }
        let tet: string | React.ReactNode = a;
        if (customComponents) {
            let cc = a.split(customComponents.name);
            if (cc && cc.length > 1) {
                tet = <Fragment>{cc[0]}{customComponents.value}{cc[1]}</Fragment>
            }
        }
        return <Fragment key={`${a}-${index}`}>{tet}{component}</Fragment>
    })
}

export default useFormattingTranslation;